// === PHOTO DATABASE === //
// Easy-to-edit photo collection for your child's website

const PHOTO_DATABASE = {
    // === FAMILY ALBUM === //
    family: [
        {
            id: 1,
            src: "assets/photos/albums/family/backyard-bubble.jpg",
            thumbnail: "assets/photos/thumbnails/backyard-bubble-thumb.jpg",
            title: "Backyard Bubble Fun",
            description: "Playing with bubbles in our backyard! I love watching them float up to the sky like little planets! 🫧✨",
            date: "2024-03-20",
            location: "Our Backyard",
            tags: ["family", "bubbles", "backyard", "playing", "outdoor", "fun"],
            photographer: "Mom",
            featured: true,
            allowDownload: true
        }
        // Add more family photos here...
    ],

    // === SCHOOL ALBUM === //
    school: [
        // Add school photos here...
    ],

    // === HOBBIES ALBUM === //
    hobbies: [
        // Add hobby photos here...
    ],

    // === SPECIAL MOMENTS ALBUM === //
    special: [
        // Add special moment photos here...
    ]
};

// === ART & CREATIONS DATABASE === //
const CREATIONS_DATABASE = {
    drawings: [
        // Add drawings here...
    ],
    crafts: [
        // Add crafts here...
    ],
    paintings: [
        // Add paintings here...
    ],
    digital: [
        // Add digital art here...
    ]
};

// === ADVENTURES DATABASE === //
const ADVENTURES_DATABASE = [
    // Add adventures here...
];

// === HELPER FUNCTIONS === //

// Get photos by album
function getPhotosByAlbum(albumName) {
    return PHOTO_DATABASE[albumName] || [];
}

// Get featured photos from all albums
function getFeaturedPhotos() {
    const featured = [];
    for (const album in PHOTO_DATABASE) {
        const albumPhotos = PHOTO_DATABASE[album].filter(photo => photo.featured);
        featured.push(...albumPhotos);
    }
    return featured.sort((a, b) => new Date(b.date) - new Date(a.date));
}

// Get creations by type
function getCreationsByType(type) {
    return CREATIONS_DATABASE[type] || [];
}

// Get all creations
function getAllCreations() {
    const allCreations = [];
    for (const type in CREATIONS_DATABASE) {
        allCreations.push(...CREATIONS_DATABASE[type]);
    }
    return allCreations.sort((a, b) => new Date(b.date) - new Date(a.date));
}

// Get items for sale
function getItemsForSale() {
    const forSale = [];
    for (const type in CREATIONS_DATABASE) {
        const saleItems = CREATIONS_DATABASE[type].filter(item => item.forSale);
        forSale.push(...saleItems);
    }
    return forSale;
}

// Search photos by tag
function searchPhotosByTag(tag) {
    const results = [];
    for (const album in PHOTO_DATABASE) {
        const matches = PHOTO_DATABASE[album].filter(photo => 
            photo.tags.includes(tag.toLowerCase())
        );
        results.push(...matches);
    }
    return results;
}

// Get photo statistics
function getPhotoStats() {
    let totalPhotos = 0;
    let totalCreations = 0;
    let totalAdventures = ADVENTURES_DATABASE.length;
    
    for (const album in PHOTO_DATABASE) {
        totalPhotos += PHOTO_DATABASE[album].length;
    }
    
    for (const type in CREATIONS_DATABASE) {
        totalCreations += CREATIONS_DATABASE[type].length;
    }
    
    return {
        photos: totalPhotos,
        creations: totalCreations,
        adventures: totalAdventures
    };
}

// Export for use in other files
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        PHOTO_DATABASE,
        CREATIONS_DATABASE, 
        ADVENTURES_DATABASE,
        getPhotosByAlbum,
        getFeaturedPhotos,
        getCreationsByType,
        getAllCreations,
        getItemsForSale,
        searchPhotosByTag,
        getPhotoStats
    };
}

// Make available globally in browser
if (typeof window !== 'undefined') {
    window.PHOTO_DATABASE = PHOTO_DATABASE;
    window.CREATIONS_DATABASE = CREATIONS_DATABASE;
    window.ADVENTURES_DATABASE = ADVENTURES_DATABASE;
    window.getPhotosByAlbum = getPhotosByAlbum;
    window.getFeaturedPhotos = getFeaturedPhotos;
    window.getCreationsByType = getCreationsByType;
    window.getAllCreations = getAllCreations;
    window.getItemsForSale = getItemsForSale;
    window.searchPhotosByTag = searchPhotosByTag;
    window.getPhotoStats = getPhotoStats;
}

// === EASY EDITING GUIDE === //
/*

HOW TO ADD NEW PHOTOS:

1. FAMILY PHOTOS:
   - Add to PHOTO_DATABASE.family array
   - Copy the structure from existing photos
   - Update id, src, title, description, date

2. SCHOOL PHOTOS:
   - Add to PHOTO_DATABASE.school array
   - Use id starting from 11, 12, 13...

3. HOBBY PHOTOS: 
   - Add to PHOTO_DATABASE.hobbies array
   - Use id starting from 21, 22, 23...

4. SPECIAL MOMENTS:
   - Add to PHOTO_DATABASE.special array
   - Use id starting from 31, 32, 33...

5. ART CREATIONS:
   - Add to appropriate CREATIONS_DATABASE category
   - Set forSale: true if you want to sell it
   - Add price if for sale

EXAMPLE NEW PHOTO:
{
    id: 4,  // Next number in sequence
    src: "assets/photos/albums/family/YOUR-PHOTO.jpg",
    thumbnail: "assets/photos/thumbnails/YOUR-PHOTO-thumb.jpg", 
    title: "Your Photo Title",
    description: "Fun description with emoji! 😊",
    date: "2024-03-01",  // YYYY-MM-DD format
    location: "Where it was taken",
    tags: ["tag1", "tag2", "tag3"],
    photographer: "Who took it",
    featured: false,  // true to show on homepage
    allowDownload: true
}

TIPS:
- Use descriptive titles and fun descriptions
- Add lots of tags for searching later  
- Set featured: true for your best photos
- Keep file names simple (no spaces or special characters)
- Always create thumbnails for faster loading

*/
